import React, { createContext, useState, useEffect } from 'react';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import PropTypes from 'prop-types';

export const RealtimeDataContext = createContext();

export const RealtimeDataProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const db = getFirestore();
    const unsubscribe = onSnapshot(
      collection(db, 'collectionName'),
      (snapshot) => {
        const newData = {};
        snapshot.forEach((doc) => {
          newData[doc.id] = doc.data();
        });
        setData(newData);
        setLoading(false);
      }
    );

    // Limpeza quando o componente é desmontado
    return () => unsubscribe();
  }, []);

  return (
    <RealtimeDataContext.Provider value={{ data, loading }}>
      {children}
    </RealtimeDataContext.Provider>
  );
};

RealtimeDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
